module.exports = __webpack_public_path__ + "img/9-21.7ed8e3d4.jpg";